import React from 'react';
import { Link } from 'gatsby';
import styled from "styled-components";
import ReklamaImg from "../assets/img/reklamaBackground2.svg";

const ArticleCtaInner = styled.div`
  margin-bottom: 60px !important;
  margin-top: 50px !important;

  div {
    border-radius: 10px;
    background: url(${ReklamaImg});
    background-repeat: no-repeat;
    background-size: 200% 100%;
    background-position: center;
    padding: 30px;
    max-width: 580px;
    margin-bottom: 0 !important;

    h2 {
      font-family: Visuelt-Bold;
      font-size: 21px !important;
      color: #28261f !important;
      margin: 0 !important;
      margin-bottom: 20px !important;
    }

    p {
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #424038 !important;
      line-height: 25px;

      .nowrap {
        white-space: nowrap;
      }

      a {
        font-family: Visuelt-Regular;
        color: #424038;
        white-space: nowrap;
      }
    }

    .ctaButton {
      font-family: Visuelt-Medium;
      font-size: 18px;
      color: #000000;
      text-align: center;
      max-width: 290px;
      display: block;
      padding: 20px 0;
      border-radius: 5px;
      background: #fff;
      text-decoration: none;
      margin-top: 30px;
    }
  }
`;

const ArticleCta = ({ ctaText, ctaLink, text, heading }) => {

  return (
    <ArticleCtaInner>
      <div>
        <h2>{heading}</h2>
        {text}
        <Link className="ctaButton" to={ctaLink}>{ctaText}</Link>
      </div>
    </ArticleCtaInner>
  );
}

export default ArticleCta;
